define(function () {
    'use strict';

    return function($rootScope, $mdToast, $filter){
        return {
            Success : function(message, keepAfterLocationChange) {
                $mdToast.show(
                    $mdToast.simple()
                        .toastClass('md-toast success')
                        .position('top right')
                        .textContent($filter('translate')(message))
                        .hideDelay (10000)
                );
            },
            Error: function(message, keepAfterLocationChange) {

                $mdToast.show(
                    $mdToast.simple()
                        .toastClass('md-toast error')
                        .position('top right')
                        .textContent($filter('translate')(message))
                        .hideDelay (10000)
                );
            }
        };
    }
});


/** WEBPACK FOOTER **
 ** ./js/services/flash.js
 **/